var values = require('object.values')
var padStart = require('string.prototype.padstart')

if (!Object.values) {
  values.shim()
}
if (!String.prototype.padStart) {
  padStart.shim()
}



// WEBPACK FOOTER //
// ./src/polyfills.js